import React from 'react'
import './style.css'
import logoKenetto from '../../../../resources/images/logoKenetto-01.svg'
import { polyglot } from '../../../../index'

const Footer = () => {
  return <footer className='footer'>
    <div className='footer-left'>
      <h3>
        <img src={logoKenetto} alt='Kenetto Logo' />
      </h3>
      <p className='footer-company-name'>Crescendo is a product of <a rel='noopener noreferrer' target='_blank' href='https://kenetto.com'>Kenetto</a> &copy; 2018</p>
    </div>
    <div className='footer-center'>
      <div>
        <i className='fa fa-envelope' />
        <p><a href={`mailto:${polyglot.t('staticFields.footer.email')}`}>{polyglot.t('staticFields.footer.email')}</a></p>
      </div>
    </div>
    <div className='footer-right'>
      <p className='footer-company-about'>
        <span>{polyglot.t('staticFields.footer.minimumBrowserRequirements.title')}</span>
        {polyglot.t('staticFields.footer.minimumBrowserRequirements.chrome')}
        <br />
        {polyglot.t('staticFields.footer.minimumBrowserRequirements.firefox')}
      </p>
    </div>
  </footer>
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/general/App/Footer/Footer.js